import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { Language, LanguageQuery } from "@roman/shared/types/Language";
import type { UserRoundEntryUnit } from "@roman/shared/types/UserRoundEntryUnit";
import { useEffect } from "react";
import useSWR from "swr";

interface UserRoundEntryUnitsResponse {
  userRoundEntryUnits: UserRoundEntryUnit[];
}

const fetcher = (url: string, lang: Language) => {
  const headers = authHeader.getOrThrow();
  return romanApi.get<UserRoundEntryUnitsResponse, LanguageQuery>(url, { lang }, { headers });
};

export const useUserRoundEntryUnits = (
  userId: string | undefined,
  handleError: (err: RomanApiError) => void,
  lang: Language = "en",
) => {
  const getKey = () => (userId ? `/soccer/roundEntryUnits/users/${userId}` : null);

  const { data, error, isLoading, mutate } = useSWR<UserRoundEntryUnitsResponse>(getKey(), (url: string) =>
    fetcher(url, lang),
  );

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error, handleError]);

  return {
    data: data ?? { userRoundEntryUnits: [] },
    mutate,
    isLoading,
  };
};
